import { render, staticRenderFns } from "./CatalogModal.vue?vue&type=template&id=0e3531e8&scoped=true&"
import script from "./CatalogModal.vue?vue&type=script&lang=js&"
export * from "./CatalogModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogModal.vue?vue&type=style&index=0&id=0e3531e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3531e8",
  null
  
)

export default component.exports